/**
 * Значения всех видимых функций при одном `x`.
 *
 * Читается вместе с вертикальным курсором на плоскости: там видно «где», а
 * здесь — «сколько». Ради этого пробник и существует: на глаз с графика
 * снимается наклон, но не число.
 */

import { cellText } from "../../lib/function-lab/controls";
import { formulaText } from "../../lib/function-lab/math";
import { formatApprox } from "../../lib/function-lab/numbers";
import type { LabScene } from "../../lib/function-lab/model";

export function ValueProbe({ scene, x }: { scene: LabScene; x: number | null }) {
  const visible = scene.curves.filter((curve) => curve.visible);
  if (x === null || !Number.isFinite(x) || visible.length === 0) {
    return <p className="fn-lab__probe-idle">
      Наведите курсор на плоскость — здесь появятся значения при этом x.
    </p>;
  }
  return <dl className="fn-lab__probe-values" aria-live="polite">
    <div><dt>x</dt><dd>{formatApprox(x, 2).replace(/^-/, "−")}</dd></div>
    {visible.map((entry) => (
      <div key={entry.id} className={`fn-lab__curve--${entry.slot}`}>
        <dt><span className="fn-lab__swatch" aria-hidden="true" />{formulaText(entry.curve)}</dt>
        <dd>{cellText(entry.curve, x)}</dd>
      </div>
    ))}
  </dl>;
}
